import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Button, Col, Row, Container} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {DatePicker} from "../form/fields/DatePicker";
import {InfoModalButton} from "../InfoModalButton";
import {HasPermission} from "../HasPermission";
import {snakeCase} from "lodash";
import {ToastContainer} from 'react-toastify';
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class SubscriptionFormData {
    @observable party_id = null;
    @observable max_users: number = 0;
    @observable amount: number = 0;
    @observable rate: number = 0;
    @observable election_type_id = null;
    @observable election_id = null;
    @observable starts_at = '';
    @observable ends_at = '';
    @observable is_active = true;
    @observable competitor_parties = [];
    @observable candidates = [];
}

export class SubscriptionForm extends CrudForm {
    modelName = 'Subscription';

    calculateAmount() {
        var amount = Number(String((this.formStore.getValue('rate') || 0) *
            this.formStore.getValue('max_users'))).toFixed(2);
        this.formStore.setValue('amount', amount);
    }

    getAmount() {
        return Number(this.formStore.getValue('amount') *
            this.formStore.getValue('candidates').length).toFixed(2);

    }

    renderFields() {
        return (
            <>
                <Field
                    label="Party"
                    name="party_id"
                    component={Select}
                    required={true}
                    loadOptions={() => {
                        return api.party.getListAction().then((data: any) => {
                            return data.data;
                        });
                    }}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('competitor_parties', []);
                    }}
                />

                <Row className="form-row">
                    <Col md={6}>
                        <Field
                            label="Max Users"
                            name="max_users"
                            type="number"
                            component={Input}
                            required={true}
                            store={this.formStore}
                            onChange={this.calculateAmount()}
                        />
                    </Col>

                    <Col md={6}>
                        <Field
                            label="Rate/User"
                            name="rate"
                            type="number"
                            component={Input}
                            required={true}
                            store={this.formStore}
                            onChange={this.calculateAmount()}
                        />
                    </Col>
                </Row>

                <div className="position-relative form-group">
                    <label htmlFor="amount" className="">Amount: {this.getAmount()}</label>
                </div>

                <Field
                    label="Election Type"
                    name="election_type_id"
                    component={Select}
                    required={true}
                    loadOptions={api.electionType.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('election_id', null);
                    }}
                />

                <Field
                    key={this.formStore.getValue('election_type_id') + 'election'}
                    label="Election"
                    name="election_id"
                    component={Select}
                    required={true}
                    loadOptions={() => {
                        return api.election.getListAction({
                            filters: {
                                election_type_id: this.formStore.getValue('election_type_id'),
                                election_pending: 1
                            }
                        });
                    }}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('competitor_parties', []);
                    }}
                />

                <Field
                    key={this.formStore.getValue('party_id') + this.formStore.getValue('election_id') + 'other_parties'}
                    label="Competitor Parties"
                    name="competitor_parties"
                    component={Select}
                    multi={true}
                    disabled={!this.formStore.getValue('party_id')}
                    required={true}
                    valueObject={true}
                    loadOptions={() => {
                        return api.party.getListAction({
                            filters: {
                                except_party_id: this.formStore.getValue('party_id'),
                                //election_id: this.formStore.getValue('election_id'),
                            }
                        }).then((data: any) => {
                            return data.data;
                        });
                    }}
                    store={this.formStore}
                />

                <Row className="form-row">
                    <Col md={6}>
                        <Field
                            label="Starts at"
                            name="starts_at"
                            component={DatePicker}
                            required={true}
                            store={this.formStore}
                        />
                    </Col>

                    <Col md={6}>
                        <Field
                            label="Ends at"
                            name="ends_at"
                            component={DatePicker}
                            required={true}
                            store={this.formStore}
                        />
                    </Col>
                </Row>

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class SubscriptionFilterForm {
    @observable election_type_id = '';
    @observable election_id = '';
}

export class SubscriptionList extends CrudList {
    modelName = 'Subscription';
    @observable isDisabled = false;

    getCompetitorParties = (value: any, item: any) => {
        if (!value.length) {
            return '-';
        }
        return (
            <InfoModalButton
                buttonClass=""
                modalTitle="Competitor Parties"
                text=""
                icon="icon-podium"
            >
                <ol>
                    {value.map((item: any) => {
                        return (<li key={item.id}>{item.name}</li>)
                    })}
                </ol>
            </InfoModalButton>
        );
    };

    colums() {
        return [
            {
                name: "party.name",
                label: "Party",
				sort: true,
            },
            {
                name: "max_users",
                label: "Max Users",
				sort: true,
            },
            {
                name: "rate",
                label: "Rate/User",
				sort: true,
            },
            {
                name: "amount",
                label: "Amount(₦)",
                formatter: (value: any, item: any) => {
                    return Number((value * item.candidates.length)).toFixed(2)
                },
				sort: true,
            },
            {
                name: "is_active",
                label: "Status",
                formatter: (value: any, item: any) => {
                    if (value) {
                        return (
                            <>
                             <Button key={'include-' + item.id} color="polling-unit-status"
                                              disabled={this.isDisabled}
                                              onClick={() => {
                                                  if (!this.isDisabled) {
                                                      this.updateStatus(item);
                                                  }
                                              }}>
                                <span className="badge badge-success">Active</span>
                                </Button>
                            </>
                        );
                    }
                    return (
                        <>
                        <Button key={'exclude-' + item.id} color="polling-unit-status"
                                                    disabled={this.isDisabled}
                                                    onClick={() => {
                                                        if (!this.isDisabled) {
                                                            this.updateStatus(item);
                                                        }
                                                    }}>
                            <span className="badge badge-danger">Inactive</span>
                            </Button>
                        </>
                    );
                },
				sort: true,
            },
            {
                name: "candidates",
                label: "Candidates",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            <Button color="candidates" onClick={() => this.goToCandidates(item.id)}><span
                                className="icon-candidates"/></Button> <span
                            className="badge badge-success font-weight-bold">{value.length}</span>
                        </>
                    );
                },
            },
            {
                name: "competitor_parties",
                label: "Competitor Parties",
                formatter: this.getCompetitorParties,
            },
        ];
    }

    idColumn() {
        return '';
    }

    goToCandidates(subscriptionId: any) {
        window.location.href = '/subscription/' + subscriptionId + '/candidates';
    }

    defaultActions() {
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any) => {
                return (
                    <>
                        <HasPermission module={snakeCase(this.modelName)} permission="edit">
                            <Button color="grid" onClick={() => this.props.onEdit(value)} size="sm"
                                    className="btn-edit"><span className="icon-edit"/></Button>
                        </HasPermission>
                    </>
                );
            },
            style: {whiteSpace: 'nowrap', textAlign: 'center'},
        }
    }

    updateStatus(item: any) {
        this.isDisabled = true;
         if (confirm('Are you sure you want to update status?')) {
            api.subscription.postUpdateStatusAction(item.id || '', {
                'is_active': !item.is_active
            }).then(() => {
                this.listTableStore.refresh();
                this.isDisabled = false;
                toast.success('Record Updated successfully!');
            }) 
        } else {
            this.isDisabled = false;
        }  
    }

    renderFilters() {
        return (
            <Container>

            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
                </Row>
            <Row className="form-row">
                <Col md={3}>
                    <Field
                        name="election_type_id"
                        placeholder="Select Election Type"
                        component={Select}
                        required={true}
                        loadOptions={api.electionType.getListAction}
                        store={this.filterFormStore}
                        onChange={() => {
                            this.filterFormStore.setValue('election_id', null);
                        }}
                    />
                </Col>

                <Col md={3}>
                    <Field
                        key={'filter' + this.filterFormStore.getValue('election_type_id') + 'election'}
                        placeholder="Select Election"
                        name="election_id"
                        component={Select}
                        required={true}
                        loadOptions={() => {
                            return api.election.getListAction({
                                filters: {
                                    election_type_id: this.filterFormStore.getValue('election_type_id'),
                                }
                            });
                        }}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class SubscriptionPage extends CrudPage {
    modelName = 'Subscription';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/SubscriptionPage.tsx